import React, { forwardRef } from 'react'
import './ui.css'

/** Многострочное поле в стиле новой DS (класс ds-textarea). */
const Textarea = forwardRef(function Textarea({ className = '', ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={`ds-textarea${className ? ` ${className}` : ''}`}
      {...props}
    />
  )
})

Textarea.displayName = 'Textarea'

export default Textarea
